import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Trophy } from "lucide-react";
import { mediaUrl } from "../lib/api";

export function CaseStudyCard({ story: c, bg = "bg-slate-50", fallbackIcon: Icon = Trophy, showCta = false, testid }) {
  return (
    <Link to={`/success-stories/${c.slug}`} data-testid={testid} className={`group block h-full ${bg} rounded-2xl border border-navy/5 overflow-hidden hover:-translate-y-1 transition-all`}>
      <div className="aspect-[16/10] overflow-hidden flex items-center justify-center">
        {c.image ? <img loading="lazy" decoding="async" src={mediaUrl(c.image, 800)} alt={c.image_alt || c.title} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" /> : <Icon size={40} className="text-orange" />}
      </div>
      <div className="p-6">
        {c.logo ? (
          <img loading="lazy" decoding="async" src={mediaUrl(c.logo, 300)} alt={c.client_name || "Client logo"} className="h-6 w-auto max-w-[140px] object-contain mb-3" />
        ) : (c.client_name || c.industry) ? (
          <span className="block text-xs font-bold text-orange uppercase tracking-wider mb-2">{[c.client_name, c.industry].filter(Boolean).join(" · ")}</span>
        ) : null}
        {c.result && <span className="inline-block text-xs font-bold text-orange bg-orange/10 rounded-full px-3 py-1 mb-3">{c.result}</span>}
        <h3 className="font-display font-bold text-lg text-navy mb-2 leading-snug">{c.title}</h3>
        {c.quote && <p className="text-sm text-slate-600 italic mb-2 leading-relaxed">“{c.quote}”</p>}
        <p className="text-sm text-slate-500 line-clamp-2">{c.summary}</p>
        {showCta && <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-navy group-hover:gap-2.5 transition-all">Read the story <ArrowRight size={15} /></span>}
      </div>
    </Link>
  );
}
